import React from 'react';
import { PopoverContainer, DropdownContainer } from "./Popover.styles";
import { Popover as MantinePopover } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';


type PopoverProps = {
  targetContent: React.ReactNode;
  dropdownContainer?: React.FC;
  dropdownContent: React.ReactNode;
};
const Popover: React.FC<PopoverProps> = ({ targetContent, dropdownContainer, dropdownContent }) => {
  const [opened, { close, open }] = useDisclosure(false);

  const DropDownContainer = dropdownContainer ?? DropdownContainer;
  return (
      <PopoverContainer position="bottom" offset={10} withArrow shadow="md" opened={opened}>
        <MantinePopover.Target>
          <span onMouseEnter={open} onMouseLeave={close}>{targetContent}</span>
        </MantinePopover.Target>
        <DropDownContainer>
          {dropdownContent}
        </DropDownContainer>
    </PopoverContainer>
  )
}

export default Popover;
